import { DatatableFocusAreaTemplateColumn } from "@/domain/focus-area/components/datatable-focus-area-column/datatable-focus-area-template-column";
import { Workspace } from "@/domain/workspace/models/workspace-model";

import { Project } from "../../../models/project-model";

export const COLUMN_ID_PROJECT_FOCUS_AREA = "focus_area";
export const COLUMN_ORDER_VALUE_PROJECT_FOCUS_AREA = 201;

interface ProjectFocusAreaColumnProps {
  workspace: Workspace;
  columnId?: string;
  orderValue?: number;
  displayValue: string;
  editable?: boolean;
}

export const ProjectFocusAreaColumn = ({
  workspace,
  columnId = COLUMN_ID_PROJECT_FOCUS_AREA,
  orderValue = COLUMN_ORDER_VALUE_PROJECT_FOCUS_AREA,
  displayValue,
  editable = false,
}: ProjectFocusAreaColumnProps) => {
  return DatatableFocusAreaTemplateColumn<Project>({
    workspace,
    columnId,
    orderValue,
    displayValue,
    editable,
    focusAreaInstanceFromRow: (row) => row.focusAreaInstance ?? null,
    ownerIdFromRow: (row) => row.id,
  });
};
